"use strict";

module.exports = function (accumulator, order, product, component) {
  return accumulator + '-' + component.wrapper_color.replace(' ', '');
};